<template>
  <div>
    <Title title="Reportería de Geocodificación"
           subtitle="Descarga el histórico de geocodificación"/>
    <div v-loading="loadReport">
      <el-row>
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker v-model="dateRange"
                            format="dd-MM-yyyy"
                            type="daterange"
                            range-separator="A"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Seleccione inicio"
                            end-placeholder="Seleccione término">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="verifyRange"
                       class="default"
                       :disabled="disabled || loadSearch">
              <i class="fa fa-search"/>
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <div v-loading="loadSearch">
        <div v-if="report" style="height: 430px;">
          <div style="text-align: left">
            <p class="titleRep"><el-icon class="el-icon-s-claim"></el-icon>Resumen reporte</p>
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card shadow="hover" class="boxTit">
                  <div style="text-align: left">
                    <p>Rango Fechas</p>
                  </div>
                  <div class="line"></div>
                  <div style="text-align: left">
                    <p>{{ reportDateRange }}</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row :gutter="5" style="margin-top: 10px;">
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left;"><el-icon class="el-icon-document"/></div>
                  <div style="text-align: center">
                    <span>{{report.total}}</span>
                  </div>
                  <div class="line"></div>
                  <p>Total Folios</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><i class="fas fa-map-marker-alt"/></div>
                  <div style="text-align: center"><span>{{report.count_centroide}}</span></div>
                  <div class="line"></div>
                  <p>Cantidad Centroides</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><i class="far fa-edit"/></div>
                  <div style="text-align: center"><span>{{report.count_asistida}}</span></div>
                  <div class="line"></div>
                  <p>Cantidad Asistidos</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><i class="far fa-hand-paper"/></div>
                  <div style="text-align: center"><span>{{report.count_manual}}</span></div>
                  <div class="line"></div>
                  <p>Cantidad Manuales</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><i class="fas fa-check-double"/></div>
                  <div style="text-align: center"><span>{{report.count_corregido}}</span></div>
                  <div class="line"></div>
                  <p>Cantidad Corregidos</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><i class="far fa-question-circle"/></div>
                  <div style="text-align: center"><span>{{report.count_no_encontrado}}</span></div>
                  <div class="line"></div>
                  <p>Cantidad No encontrados</p>
                </el-card>
              </el-col>
            </el-row>
            <div style="text-align: left">
              <p class="titleRep-2">
          <span style="font-size: 8px;" class="fa-stack small fa-lg tooltipStyle">
            <i class="fas fa-file fa-stack-2x"></i>
            <i class="fas fa-download fa-stack-1x fa-inverse"></i>
          </span>
                Descarga de reporte
              </p>
            </div>
            <div style="text-align: left">
        <span style="font-size: 14px;margin-left: 10px;">El archivo tiene extensión .csv, lo
          puedes abrir con Excel. La separación de las columnas es con punto y coma (;) </span>
            </div>
            <el-row>
              <div v-if="loading" style="text-align: left; margin-top: 10px;">
                <el-button type="primary"
                           icon="el-icon-loading"
                           :disabled="loading"
                           @click="exportReport"
                           size="small">GENERANDO ARCHIVO
                </el-button>
              </div>
              <div v-else style="text-align: left; margin-top: 10px;">
                <el-button type="primary"
                           icon="el-icon-download"
                           @click="exportReport"
                           size="small">DESCARGAR
                </el-button>
              </div>
            </el-row>
          </div>
        </div>
        <div v-else
             class="messageFilter">
          <img class="imageTruck" :src="require('@/assets/img/fb-driver.svg')">
          <p class="titleMessage">Ingresa los filtros para obtener tu reporte</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';
import Title from '../components/base/Title.vue';
import { apiRequest, getReport2 } from '../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../observability/datadogRum';

export default {
  name: 'ReporterGeo',
  components: {
    Title,
  },
  data() {
    return {
      dateRange: null,
      enterprise: '',
      loadSearch: false,
      loadReport: false,
      loading: false,
      report: '',
    };
  },
  methods: {
    verifyRange() {
      const difference = new Date(this.dateRange[1]).getTime()
        - new Date(this.dateRange[0]).getTime();
      if (difference / (1000 * 3600 * 24) > 4) {
        this.$notify.warning({
          title: 'Rango máximo 5 días',
          message: 'Seleccione un rango menor',
        });
      } else {
        this.search();
      }
    },
    search() {
      this.report = '';
      this.loadSearch = true;
      const startedAt = startRumTiming();
      const params = {
        date_init: this.dateRange[0],
        date_finish: this.dateRange[1],
      };
      trackBusinessFlow({
        module: 'reporting',
        flow: 'geocoding_report',
        action: 'search_requested',
        status: 'attempt',
      });
      apiRequest({
        module: 'tracing',
        service: 'get_summary_geo_report',
        params,
      }).then((response) => {
        this.report = response.data;
        this.report.dateFrom = params.date_init;
        this.report.dateUp = params.date_finish;
        trackBusinessFlow({
          module: 'reporting',
          flow: 'geocoding_report',
          action: 'search_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            result_total: response.data.total,
            result_manual: response.data.count_manual,
            result_corrected: response.data.count_corregido,
          },
        });
      }).catch((e) => {
        const status = e.response && e.response.status === 404 ? 'empty' : 'error';
        trackBusinessFlow({
          module: 'reporting',
          flow: 'geocoding_report',
          action: 'search_completed',
          status,
          durationMs: getRumDuration(startedAt),
          context: {
            http_status: e.response ? e.response.status : 0,
          },
        });
        if (e.response.status === 404) {
          this.$notify.warning({
            title: 'Sin coincidencias',
            message: 'Prueba con datos distintos',
          });
        } else {
          this.$notify.error({
            title: 'Error interno',
            message: 'No se pudo realizar la consulta',
          });
        }
      }).finally(() => {
        this.loadSearch = false;
      });
    },
    formatDate(date) {
      return moment.utc(date).format('DD-MM-YYYY');
    },
    exportReport() {
      this.loadReport = true;
      this.$message({ message: 'Generando resumen del reporte' });
      const startedAt = startRumTiming();
      const params = {
        date_init: this.report.dateFrom,
        date_finish: this.report.dateUp,
      };
      trackBusinessFlow({
        module: 'reporting',
        flow: 'geocoding_report',
        action: 'export_requested',
        status: 'attempt',
      });
      getReport2({
        module: 'tracing',
        service: 'get_geo_report',
        pathparams: params,
      }).then((response) => {
        this.loadReport = false;
        return response.status === 200 ? response.blob() : null;
      }).then((blob) => {
        saveAs(blob, 'reporte-geocodificacion.csv');
        trackBusinessFlow({
          module: 'reporting',
          flow: 'geocoding_report',
          action: 'export_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
        });
      }).catch((e) => {
        this.loadReport = false;
        trackBusinessFlow({
          module: 'reporting',
          flow: 'geocoding_report',
          action: 'export_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            error_message: e.message,
          },
        });
        const messageRes = e.message;
        this.$notify.error({
          title: 'Error',
          message: `${messageRes}`,
        });
      });
    },
  },
  computed: {
    disabled() {
      return this.dateRange === null;
    },
    reportDateRange() {
      return this.report.dateFrom && this.report.dateUp
        ? `DEL ${this.formatDate(this.report.dateFrom)}
        AL ${this.formatDate(this.report.dateUp)}` : '';
    },
  },
};

</script>

<style lang="scss" scoped>
  .boxRep {
    border-radius: 10px;
    height: 170px;
    position: relative;
    span {
      font-size: 40px;
      font-weight: 300;
      line-height: 70px;
      color: #707070;
    }
    i {
      font-size: 30px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-download {
      font-size: 50px;
      line-height: 90px;
    }
    .line {
      height: 2px;
      margin-top: 0;
      background: #AAD500;
    }
    p {
      font-size: 12px;
      color: #707070;
      margin: 10px 0 10px 0;
      text-transform: uppercase;
    }
  }
  .boxTit {
    border-radius: 10px;
    height: 100px;
    position: relative;
    span {
      font-size: 40px;
      font-weight: 300;
      line-height: 70px;
      color: #707070;
    }
    .line {
      height: 2px;
      margin-top: 0px;
      background: #AAD500;
    }
    p {
      font-size: 12px;
      color: #707070;
      margin: 10px 0 10px 0;
      text-transform: uppercase;
    }
  }
  .el-icon-s-claim {
    color: #AAD500;
    margin-right: 8px;
  }
  .searchBttn {
    height: 40px;
  }
  .titleRep {
    color: #707070;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 25px;
  }
  .titleRep-2 {
    color: #707070;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  .wrap {
    display: block;
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
  }
  .messageFilter{
    text-align: center;
    background-color: #ffffff;
    height: 500px;
    margin-left:5px;
    .titleMessage{
      margin-top: 40px;
      color: #AAD500;
      font-size: 16px;
      text-transform: uppercase;
    }
    .imageTruck{
      height: 200px;
      margin-top: 50px;
    }
  }
  .el-form {
    .el-button { height: 40px; }
    .el-date-editor { margin-top: 1px; }
  }
</style>
